import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Collapse } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import {
    DeletarPerfilFinanceiroController,
    ListarPerfilFinanceiroController,
} from "../../../../../../Controllers/Geral/GestaoDeCadastros/PerfilFinanceiro/PerfilFinanceiroController";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import { IPerfilFinanceiro } from "../../../../../../Interfaces/Geral/GestaoDeCadastro/PerfilFinanceiro/PerfilFinanceiroInterface";
import Table from "../../../../../Table";
import CadastroPerfilFinanceiro from "./CadastrarPerfilFinanceiro";

interface IPerfilFinanceiroProps {
    editting: boolean;
}

export default function PerfilFinanceiro(props: IPerfilFinanceiroProps) {
    const [editando, setEditando] = useState(false);
    const [rowPerfil, setRowPerfil] = useState<IPerfilFinanceiro>();

    const {
        value: lstPerfilFinanceiro,
        loading: lstPerfilFinanceiroLoading,
        execute: listarPerfilFinanceiro,
    } = useAsyncEffect(() => ListarPerfilFinanceiroController());

    const columns: Array<ColumnDescription<IPerfilFinanceiro>> = [
        {
            dataField: "DS_PERFIL_FINANCEIRO_CONTA",
            text: "Perfil Financeiro",
            formatter: (c, row) => (
                <div className="d-flex justify-content-between align-items-center p-3 g-2">
                    <div className="d-flex align-items-center g-3">
                        <i
                            className={`${row.DS_ICON_PERFIL_FINANCEIRO_CONTA}`}
                            style={{ color: row.HX_COR_PERFIL_FINANCEIRO_CONTA }}
                        />
                        <div>
                            <h6>{row.DS_PERFIL_FINANCEIRO_CONTA}</h6>
                            <div className="d-flex flex-wrap g-1">
                                <span
                                    className={`label label-${
                                        row.FL_ATIVO ? "success" : "danger"
                                    } abel-pill label-inline mr-2`}
                                >
                                    {row.FL_ATIVO ? "Ativo" : "Desativado"}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap g-2">
                        <button
                            className="btn btn-icon btn-outline-danger"
                            onClick={() => {
                                DeletarPerfilFinanceiroController(
                                    row.ID_PERFIL_FINANCEIRO_CONTA ?? 0
                                ).then(() => listarPerfilFinanceiro());
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                        <button
                            className="btn btn-icon btn-outline-primary"
                            onClick={() => {
                                setEditando(true);
                                setRowPerfil(row);
                            }}
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </button>
                    </div>
                </div>
            ),
        },
    ];
    return (
        <div>
            <div className="col-12 collapse mb-5" id="collapseForm">
                <CadastroPerfilFinanceiro
                    editando={false}
                    updateList={listarPerfilFinanceiro}
                />
            </div>
            <Table
                keyField="ID_TIPO_CLIENTE"
                data={lstPerfilFinanceiro ?? []}
                loading={lstPerfilFinanceiroLoading}
                columns={columns}
                noDataIndication={"Não existem perfis financeiros"}
            />
            <Collapse in={!!editando} mountOnEnter unmountOnExit>
                <CadastroPerfilFinanceiro
                    editando={editando}
                    updateList={listarPerfilFinanceiro}
                    rowPerfil={rowPerfil}
                />
            </Collapse>
        </div>
    );
}
